// The number the Relationships tab's strip count promises (#11426).
//
// The tab renders every linked record — entity-valued facts AND
// backreferences, deduplicated by entity id — so its count must count the
// same set. It previously counted backreferences alone, which read
// "Relationships 0" over a tab showing a linked person the moment the link
// lived on a fact.

import type { EntitySchema, Fact } from "../types";

export function relationshipCount(entity: EntitySchema): number {
  const ids = new Set<string>();
  for (const fact of entity.facts as Fact[]) {
    if ("array" in fact) {
      for (const value of fact.array) {
        if (value.entity) ids.add(value.entity.id);
      }
    } else if (fact.entity) {
      ids.add(fact.entity.id);
    }
  }
  for (const group of entity.backreferences ?? []) {
    for (const item of group.entities) {
      if (item.entity) ids.add(item.entity.id);
    }
  }
  return ids.size;
}
